export const CUSTOM_HEADERS = {
  XTIMESTAMP: 'x-timestamp',
  XSIGNATURE: 'x-signature'
};
